import country from './en-US/country.json'
import money from './en-US/money.json'
import register from './en-US/register.json'
import footer from './en-US/footer.json'
import sider from './en-US/sider.json'
import header from './en-US/header.json'
import errorANDwarning from './en-US/error&warning.json'
import pv from './en-US/PV.json'
import inverter from './en-US/Inverter.json'
import action from './en-US/action.json'
import formGeneral from './en-US/formGeneral.json'
import tableGeneral from './en-US/tableGeneral.json'
import project from './en-US/project.json'
import report from './en-US/report.json'
import investmentTable from './en-US/investmentTable.json'
import gainTable from './en-US/gainTable.json'
import acPowerTable from './en-US/acPowerTable.json'
import lossTable from './en-US/lossTable.json'
import irrTable from './en-US/irradianceTable.json'
import emissionReduction from './en-US/emissionReduction.json'
import chart from './en-US/chart.json'
import techSupport from './en-US/techSupport.json'
import WeatherAnalysisTable from './en-US/weatherAnalysisTable.json'
import WeatherManager from './en-US/weatherManager.json'

export default {
  ...country,
  ...money,
  ...register,
  ...footer,
  ...sider,
  ...header,
  ...errorANDwarning,
  ...pv,
  ...inverter,
  ...action,
  ...formGeneral,
  ...tableGeneral,
  ...project,
  ...report,
  ...investmentTable,
  ...gainTable,
  ...acPowerTable,
  ...lossTable,
  ...irrTable,
  ...emissionReduction,
  ...chart,
  ...techSupport,
  ...WeatherAnalysisTable,
  ...WeatherManager,
}
